import script from "./InputDynamicSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./InputDynamicSearch.vue?vue&type=script&setup=true&lang=js"

import "./InputDynamicSearch.vue?vue&type=style&index=0&id=33d94f2c&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d94f2c"]])

export default __exports__